<script>
  import { slide } from 'svelte/transition';
  import _ from 'lodash';
  const apiKey = 'AIzaSyAYh7_1VbfUr-tziqxLRZ9CqMnSngs-HlU';
  const sheetID = '1T_5pbpaqb7QSC0nWCkMvbaPr5M7LgT_YZEoCjU8Lf0s';
  const range = 'HP用!A1:Z100';
  const apiURL = `https://sheets.googleapis.com/v4/spreadsheets/${sheetID}?key=${apiKey}&includeGridData=true&ranges=${range}&fields=sheets.data.rowData.values(effectiveValue,effectiveFormat,formattedValue)`;

  let baseRecords = [{}];
  let filteredRecords = baseRecords;
  async function getTable() {
    let resp = await fetch(apiURL);
    let jsonData = await resp.json();
    if (jsonData.error) { throw jsonData.error; }
    else {
      baseRecords = jsonData.sheets[0].data[0].rowData;
      filteredRecords = _.cloneDeep(baseRecords);
    }
  }
  const promise = getTable();

  let columns = [];
  let rows = [];
  let cells = [[]];
  $: {
    if (filteredRecords.length > 1) {
      columns = filteredRecords[0].values
        .filter((_, i) => {
          return filteredRecords.map((r) => {
            return 'formattedValue' in r.values[i];
          }).reduce((prev, curV) => { return prev || curV; }, false);
        });
      rows = filteredRecords.slice(1).map((r) => {
        return r.values[0];
      }).filter((r) => {
        return 'formattedValue' in r;
      });
    }
    cells = filteredRecords.slice(1).map((r) => {
      return r.values.slice(1, columns.length);
    })
  }

  function onClickReset() {
    filteredRecords = _.cloneDeep(baseRecords);
  }

  function onClickDebug() {
    console.info(cells);
  }

  function onClickCompare(_ev) {
    const checkedRows = document.querySelectorAll(
      `input:checked[name^="filter-row-"][type="checkbox"]`
    );
    if (checkedRows.length > 0) {
      const rowList = [...checkedRows].map((elm) => {
        return parseInt(elm.name.replace(/filter-row-([0-9]+)/g, "$1"));
      });
      filteredRecords = filteredRecords.filter((d, i) => {
        if (rowList.includes(i) || i == 0) return d;
      });
    }

    const checkedColumns = document.querySelectorAll(
      `input:checked[name^="filter-column-"][type="checkbox"]`
    );
    if (checkedColumns.length > 0) {
      const columnList = [...checkedColumns].map((elm) => {
        return parseInt(elm.name.replace(/filter-column-([0-9]+)/g, "$1")) - 1;
      });
      columnList.unshift(0);
      filteredRecords = filteredRecords.map((d) => {
        d.values = d.values.filter((_, i) => {
          return (columnList.includes(i) || i == 0);
        });
        return d;
      });
    }

    [...document.querySelectorAll(
      `input[name^="filter-"][type="checkbox"]`
    )].map((elm) => {
      elm.checked = false;
    });
  }

  function isHeaderRow(row) {
    return ! /^<strong>.*<\/strong>/.test(row.effectiveValue.stringValue);
  }

  function getRGB(prop) {
    let rgb = "#";
    Object.keys(prop).forEach((c) => {
      rgb += Math.round(prop[c] * 255).toString(16).padStart(2, '0');
    });

    return rgb;
  }

  function replaceBr(str) {
    return str.replace(/\n/g, '<br />');
  }

  function getStyle(cell) {
    if ('effectiveFormat' in cell) {
      return `background-color: ${getRGB(cell.effectiveFormat.backgroundColor)}`
    } else {
      return '';
    }
  }
</script>

<main>
  {#await promise}
    <p class="loading">Loading...</p>
  {:then _table}
    <div class="compare-table-scroll">
      <table class="compare-table">
        <tr class="compare-table-record compare-table-head" transition:slide={{ duration: 300 }}>
          {#each columns as column, i}
            <th class="compare-table-block column-head">
              {#if i != 0}
                <input type="checkbox" name="filter-column-{i+1}" id="filter-column-{i+1}">
              {/if}
              <label for="filter-column-{i+1}">
                {#if 'effectiveValue' in column}
                  {@html replaceBr(column.effectiveValue.stringValue)}
                {/if}
              </label>
            </th>
          {/each}
        </tr>
        {#each rows as row, i}
          <tr class="compare-table-record" transition:slide={{ duration: 300 }}>
            <th class="compare-table-block row-head sticky" style={getStyle(row)}>
              {#if isHeaderRow(row)}
                <input type="checkbox" name="filter-row-{i+1}" id="filter-row-{i+1}">
              {/if}
              <label for="filter-row-{i+1}">
                {@html replaceBr(row.effectiveValue.stringValue)}
              </label>
            </th>
            {#each cells[i] as cell}
              <td class="compare-table-block" style={getStyle(cell)}>
                  {#if 'effectiveValue' in cell}
                    {@html replaceBr(cell.effectiveValue.stringValue)}
                  {/if}
                </td>
            {/each}
          </tr>
        {/each}
      </table>
    </div>
  {:catch error}
    <p style="color: red">{error.message}</p>
  {/await}
  <div class="console">
    <button on:click={onClickCompare} type="button" name="compare">Compare</button>
    <button on:click={onClickReset} type="button" name="reset">Reset</button>
    <!--
      <button on:click={onClickDebug} type="button" name="debug">debug</button>
    -->
  </div>
</main>

<style>
</style>
